const API_URL_dash =
  process.env.NODE_ENV === "production"
    ? "https://app.clif.ai"
    : "http://localhost:3001"; // yeh tumhara local server ka IP hai

export default API_URL_dash;
